import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import browserHistory from '../../history';
import AgendaWidget from './AgendaWidget';
import MenuWidget from './MenuWidget';
import FavoritesWidget from './FavoritesWidget';
import HistoryWidget from './HistoryWidget';
import WEBPI2Widget from './WEBPI2Widget';
import WEBPI2AllWidget from './WEBPI2AllWidget';
import WEBPI1Widget from './WEBPI1Widget';
import WEBPI1AllWidget from './WEBPI1AllWidget';
import WEBAR2Widget from './WEBAR2Widget';
import WEBAP2Widget from './WEBAP2Widget';
import WEBRO2Widget from './WEBRO2Widget';
import SRF12Widget from './SRF12Widget';
import SMP2Widget from './SMP2Widget';
import SSR11Widget from './SSR11Widget';
import SRF9Widget from './SRF9Widget';

export default {
  menu: {
    widget: MenuWidget,
  },
  history: {
    title: 'Recently Viewed Pages',
    show: true,
    order: 0,
    layout: {
      x: 0,
      y: 0,
      w: 6,
      h: 1,
    },
    widget: HistoryWidget,
  },
  favorites: {
    title: <Link to="/favorites">Favorites</Link>,
    show: true,
    order: 1,
    widget: FavoritesWidget,
    layout: {
      x: 6,
      y: 0,
      w: 6,
      h: 1,
    },
    menu: [<div onClick={() => browserHistory.push('/Favorites')}>Manage</div>],
  },
  agenda: {
    title: <Link to="/SDC0">{`${moment().format('MMM Do')} Events`}</Link>,
    description: 'Agenda',
    show: true,
    order: 2,
    layout: {
      x: 0,
      y: 1,
      w: 6,
      h: 1,
    },
    permissions: ['SDC0'],
    widget: AgendaWidget,
    page: 'SDC0',
  },
  webpi2: {
    title: "Today's Part Sales",
    show: true,
    order: 3,
    layout: {
      x: 6,
      y: 1,
      w: 6,
      h: 1,
    },
    permissions: ['WEBPI2'],
    widget: WEBPI2Widget,
    page: 'WEBPI2',
  },
  webpi2all: {
    title: "Today's Part Sales - All Stores",
    show: true,
    order: 3,
    layout: {
      x: 6,
      y: 1,
      w: 6,
      h: 1,
    },
    permissions: ['WEBPI2'],
    widget: WEBPI2AllWidget,
    page: 'WEBPI2',
  },
  webpi1: {
    title: 'Current Month Part Sales',
    show: true,
    order: 4,
    layout: {
      x: 0,
      y: 2,
      w: 6,
      h: 1,
    },
    permissions: ['WEBPI1'],
    widget: WEBPI1Widget,
    page: 'WEBPI1',
  },
  webpi1all: {
    title: 'Current Month Part Sales - All Stores',
    show: true,
    order: 4,
    layout: {
      x: 0,
      y: 2,
      w: 6,
      h: 1,
    },
    permissions: ['WEBPI1'],
    widget: WEBPI1AllWidget,
    page: 'WEBPI1',
  },
  webar2: {
    title: 'Accounts Receivable Aging Breakdown',
    show: true,
    order: 5,
    layout: {
      x: 6,
      y: 2,
      w: 6,
      h: 1,
    },
    permissions: ['WEBAR2A'],
    widget: WEBAR2Widget,
    page: 'WEBAR2A',
  },
  webap2: {
    title: 'Accounts Payable Aging Breakdown',
    show: true,
    order: 6,
    layout: {
      x: 0,
      y: 3,
      w: 6,
      h: 1,
    },
    permissions: ['WEBAP2'],
    widget: WEBAP2Widget,
    page: 'WEBAP2',
  },
  webro2: {
    title: 'Shop Status',
    show: false,
    order: 99,
    permissions: ['WEBRO2'],
    widget: WEBRO2Widget,
    page: 'WEBRO2',
  },
  srf12: {
    title: 'Service Writer Performance for Month',
    show: true,
    order: 7,
    layout: {
      x: 6,
      y: 3,
      w: 6,
      h: 1,
    },
    permissions: ['SRF12'],
    widget: SRF12Widget,
    page: 'SRF12',
  },
  smp2: {
    title: 'Proficiency With Hours for Month',
    show: true,
    order: 8,
    layout: {
      x: 6,
      y: 3,
      w: 6,
      h: 1,
    },
    permissions: ['SMP2'],
    widget: SMP2Widget,
    page: 'SMP2',
  },
  ssr11: {
    title: 'Elapsed Time To Close Repair Orders In The Past 90 Days',
    show: false,
    order: 9,
    layout: {
      x: 6,
      y: 3,
      w: 6,
      h: 1,
    },
    permissions: ['SSR11'],
    widget: SSR11Widget,
    page: 'SSR11',
  },
  srf9: {
    title: 'Service Writer Analysis Past 90 Days',
    show: false,
    order: 10,
    layout: {
      x: 6,
      y: 3,
      w: 6,
      h: 1,
    },
    permissions: ['SRF9'],
    widget: SRF9Widget,
    page: 'SRF9',
  },
};
